import React, { useCallback, useRef, useState, useEffect } from "react";
import {
  AppProvider,
  ActionList,
  Card,
  TextField,
  Text,
  ContextualSaveBar,
  FormLayout,
  Modal,
  Frame,
  Layout,
  Loading,
  Navigation,
  Page,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  Toast,
  TopBar,
  List,
} from "@shopify/polaris";
import {
  ExitIcon,
  PersonFilledIcon,
  ListBulletedFilledIcon,
  SettingsFilledIcon,
  InventoryFilledIcon,
  ContentFilledIcon,
  CategoriesIcon,
  AppsFilledIcon,
  CashDollarFilledIcon,
  PageIcon,
  TeamIcon,
  ClockIcon,
  BookIcon,
  PackageFilledIcon,
  PageClockFilledIcon,
  ContractFilledIcon,
  CalendarIcon,
  EmailIcon,
  PaymentFilledIcon,
  OrderFirstIcon,
  OrderIcon,
  OrderFilledIcon,
} from "@shopify/polaris-icons";
import Cookies from "js-cookie";
import logoImg from "../Assets/Images/logoWhite.svg";
import { useNavigate } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import reviewsIcon from "../Assets/Images/reviews.svg";
import membershipsIcon from "../Assets/Images/memberships.svg";
import {
  canViewClasses,
  canViewInstructors,
  canViewMemberships,
  canViewNews,
  canViewPackages,
  canViewReports,
  canViewReviews,
  canViewSessions,
  canViewUsers,
} from "../Helpers";

function NavigationLayout(props) {
  // const iconContent = () => {
  //   return (
  //     <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  //       <circle cx="10" cy="10" r="10" fill="rebeccapurple" />
  //       <circle cx="10" cy="10" r="6" fill="currentColor" />
  //       <circle cx="10" cy="10" r="3" />
  //     </svg>
  //   );
  // };
  const navigate = useNavigate();
  const defaultState = useRef({
    emailFieldValue: "dharma@jadedpixel.com",
    nameFieldValue: "Jaded Pixel",
  });
  const skipToContentRef = useRef(null);

  const [toastActive, setToastActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [nameFieldValue, setNameFieldValue] = useState(
    defaultState.current.nameFieldValue,
  );
  const [emailFieldValue, setEmailFieldValue] = useState(
    defaultState.current.emailFieldValue,
  );
  const [storeName, setStoreName] = useState(
    defaultState.current.nameFieldValue,
  );
  const [supportSubject, setSupportSubject] = useState("");
  const [supportMessage, setSupportMessage] = useState("");

  const handleSubjectChange = useCallback(
    (value) => setSupportSubject(value),
    [],
  );
  const handleMessageChange = useCallback(
    (value) => setSupportMessage(value),
    [],
  );
  const handleDiscard = useCallback(() => {
    setEmailFieldValue(defaultState.current.emailFieldValue);
    setNameFieldValue(defaultState.current.nameFieldValue);
    setIsDirty(false);
  }, []);
  const handleSave = useCallback(() => {
    defaultState.current.nameFieldValue = nameFieldValue;
    defaultState.current.emailFieldValue = emailFieldValue;

    setIsDirty(false);
    setToastActive(true);
    setStoreName(defaultState.current.nameFieldValue);
  }, [emailFieldValue, nameFieldValue]);
  const handleNameFieldChange = useCallback((value) => {
    setNameFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleEmailFieldChange = useCallback((value) => {
    setEmailFieldValue(value);
    value && setIsDirty(true);
  }, []);
  const handleSearchResultsDismiss = useCallback(() => {
    setSearchActive(false);
    setSearchValue("");
  }, []);
  const handleSearchFieldChange = useCallback((value) => {
    setSearchValue(value);
    setSearchActive(value.length > 0);
  }, []);
  const toggleToastActive = useCallback(
    () => setToastActive((toastActive) => !toastActive),
    [],
  );
  const toggleUserMenuActive = useCallback(
    () => setUserMenuActive((userMenuActive) => !userMenuActive),
    [],
  );
  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive,
      ),
    [],
  );
  const toggleIsLoading = useCallback(
    () => setIsLoading((isLoading) => !isLoading),
    [],
  );
  const toggleModalActive = useCallback(
    () => setModalActive((modalActive) => !modalActive),
    [],
  );

  const toastMarkup = toastActive ? (
    <Toast onDismiss={toggleToastActive} content="Changes saved" />
  ) : null;

  const userMenuActions = [
    // {
    //   items: [
    //     {
    //       content: "Your profile",
    //       icon: ProfileMinor,
    //       onAction: () => navigate("/profile"),
    //     },
    //   ],
    // },
    {
      items: [
        {
          content: "Log out",
          icon: ExitIcon,

          onAction: () => {
            axios
              .post(`/logout`)
              .then((result) => {
                navigate("/");
              })
              .catch((err) => {
                Cookies.set("honour-accesstoken", null);
                navigate("/");
              });
          },
        },
      ],
    },
  ];
  const customIcon = {
    viewBox: "0 0 20 20",
    body: '<g transform="scale(0.5)"><path d="M16 0 C6 0 2 4 2 14 L2 22 L6 24 L6 30 L26 30 L26 24 L30 22 L30 14 C30 4 26 0 16 0 M9 12 A4.5 4.5 0 0 1 9 21 A4.5 4.5 0 0 1 9 12 M23 12 A4.5 4.5 0 0 1 23 21 A4.5 4.5 0 0 1 23 12"></path></g>',
  };
  const contextualSaveBarMarkup = isDirty ? (
    <ContextualSaveBar
      message="Unsaved changes"
      saveAction={{
        onAction: handleSave,
      }}
      discardAction={{
        onAction: handleDiscard,
      }}
    />
  ) : null;

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={userMenuActions}
      name={Cookies.get("honour-name") && Cookies.get("honour-name")}
      initials={
        Cookies.get("honour-name") &&
        Cookies.get("honour-name").split(" ")[0].charAt(0) +
          " " +
          Cookies.get("honour-name").split(" ")[1].charAt(0)
      }
      open={userMenuActive}
      onToggle={toggleUserMenuActive}
    />
  );

  const searchResultsMarkup = (
    <ActionList
      items={[
        { content: "Shopify help center" },
        { content: "Community forums" },
      ]}
    />
  );

  const searchFieldMarkup = (
    <TopBar.SearchField
      onChange={handleSearchFieldChange}
      value={searchValue}
      placeholder="Search"
    />
  );

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      userMenu={userMenuMarkup}
      // searchResultsVisible={searchActive}
      // searchField={searchFieldMarkup}
      // searchResults={searchResultsMarkup}
      // onSearchResultsDismiss={handleSearchResultsDismiss}
      onNavigationToggle={toggleMobileNavigationActive}
      logoSuffix
    />
  );

  const navigationMarkup = (
    <Navigation location="/">
      <Navigation.Section
        items={[
          {
            url: "/",
            onClick: () => navigate("/admin/intro-screens"),
            label: "Pages Content",
            icon: ContentFilledIcon,
            selected:
              window.location.href.indexOf("/admin/intro-screens") > -1 ||
              window.location.href.indexOf("/admin/terms-and-conditions") > -1,
            subNavigationItems: [
              {
                onClick: () => navigate("/admin/intro-screens"),
                selected:
                  window.location.href.indexOf("/admin/intro-screens") > -1 &&
                  true,
                label: "Intro Screens",
              },
              {
                onClick: () => navigate("/admin/terms-and-conditions"),
                selected:
                  window.location.href.indexOf("/admin/terms-and-conditions") >
                    -1 && true,
                label: "Terms and Conditions",
              },
            ],
          },
          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/intro-screens"),
          //   label: "Intro Screens",
          //   icon: ContentFilledIcon,
          //   selected: window.location.href.indexOf("/admin/intro-screens") > -1,
          // },
          {
            url: "/",
            onClick: () => navigate("/admin/elements"),
            label: "Elements",
            icon: AppsFilledIcon,
            selected: window.location.href.indexOf("/admin/elements") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/instructors"),
            label: "Instructors",
            icon: PersonFilledIcon,
            selected: window.location.href.indexOf("/admin/instructors") > -1,
            disabled: !canViewInstructors(),
          },
          {
            url: "/",
            onClick: () => {
              localStorage.setItem("filter_element", "");
              navigate("/admin/classes");
            },
            label: "Classes",
            icon: CategoriesIcon,
            selected: window.location.href.indexOf("/admin/classes") > -1,
            disabled: !canViewClasses(),
          },
          {
            url: "/",
            onClick: () => {
              localStorage.setItem("filter_element", "");
              navigate("/admin/rooms");
            },
            label: "Rooms",
            icon: CategoriesIcon,
            selected: window.location.href.indexOf("/admin/rooms") > -1,
          },
          {
            url: "/",
            onClick: () => {
              navigate("/admin/events");
            },
            label: "Events",
            icon: CalendarIcon,
            selected: window.location.href.indexOf("/admin/events") > -1,
            disabled: !canViewClasses(),
          },
          {
            url: "/",
            onClick: () => navigate("/admin/courses"),
            label: "Courses",
            icon: ListBulletedFilledIcon,
            selected: window.location.href.indexOf("/admin/courses") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/reviews"),
            label: "Reviews",
            // icon: CategoriesIcon,
            disabled: !canViewReviews(),
            selected: window.location.href.indexOf("/admin/reviews") > -1,
            icon: () => (
              <img
                src={reviewsIcon}
                alt="Custom Icon"
                width="200"
                height="200"
                style={{ display: "block" }}
              />
            ),
          },
          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/recent-sessions"),
          //   label: "Recent Sessions",
          //   icon: PageClockFilledIcon,
          //   disabled: !canViewSessions(),
          //   selected:
          //     window.location.href.indexOf("/admin/recent-sessions") > -1,
          // },
          {
            url: "/",
            onClick: () => navigate("/admin/sessions"),
            label: "Sessions",
            icon: PageClockFilledIcon,
            disabled: !canViewSessions(),
            selected: window.location.href.indexOf("/admin/sessions") > -1,
          },
          {
            url: "/",
            onClick: () => navigate("/admin/news"),
            label: "News",
            icon: ContractFilledIcon,
            selected: window.location.href.indexOf("/admin/news") > -1,
            disabled: !canViewNews(),
          },

          {
            url: "/",
            onClick: () => navigate("/admin/packages"),
            label: "Packages",
            icon: PackageFilledIcon,
            selected: window.location.href.indexOf("/admin/packages") > -1,
            disabled: !canViewPackages(),
          },
          {
            url: "/",
            onClick: () => navigate("/admin/memberships"),
            label: "Memberships",
            icon: () => (
              <img
                src={membershipsIcon}
                alt="Custom Icon"
                width="200"
                height="200"
                style={{ display: "block" }}
              />
            ),
            selected: window.location.href.indexOf("/admin/memberships") > -1,
            disabled: !canViewMemberships(),
          },

          {
            url: "/",
            onClick: () => navigate("/admin/users"),
            label: "Users",
            icon: TeamIcon,
            selected: window.location.href.indexOf("/admin/users") > -1,
            disabled: !canViewUsers(),
          },
          {
            url: "/",
            onClick: () => navigate("/admin/orders"),
            label: "Shopify Orders",
            icon: OrderFilledIcon,
            selected: window.location.href.indexOf("/admin/orders") > -1,
          },

          {
            url: "/",
            onClick: () => navigate("/admin/logs"),
            label: "Reports",
            disabled: !canViewReports(),
            icon: BookIcon,
            selected:
              window.location.href.indexOf("/admin/logs") > -1 ||
              window.location.href.indexOf("/admin/bookings") > -1 ||
              window.location.href.indexOf("/admin/wallet-reports") > -1 ||
              window.location.href.indexOf("/admin/wallet-topup-reports") >
                -1 ||
              window.location.href.indexOf("/admin/wallet-payments") > -1,
            subNavigationItems: [
              {
                onClick: () => navigate("/admin/logs"),
                selected:
                  window.location.href.indexOf("/admin/logs") > -1 && true,
                label: "Logs",
              },
              {
                onClick: () => navigate("/admin/bookings"),
                selected:
                  window.location.href.indexOf("/admin/bookings") > -1 && true,
                label: "Bookings",
              },
              {
                onClick: () => navigate("/admin/wallet-reports"),
                selected:
                  window.location.href.indexOf("/admin/wallet-reports") > -1 &&
                  true,
                label: "Wallet Balance",
              },
              {
                onClick: () => navigate("/admin/wallet-topup-reports"),
                selected:
                  window.location.href.indexOf("/admin/wallet-topup-reports") >
                    -1 && true,
                label: "Wallet Top-up Payment",
              },
              {
                onClick: () => navigate("/admin/wallet-payments"),
                selected:
                  window.location.href.indexOf("/admin/wallet-payments") > -1 &&
                  true,
                label: "Wallet Payments",
              },
            ],
          },
          {
            url: "/",
            onClick: () => navigate("/admin/subscriptions"),
            label: "Subscriptions",
            icon: PaymentFilledIcon,
            selected: window.location.href.indexOf("/admin/subscriptions") > -1,
          },

          // {
          //   url: "/",
          //   onClick: () => navigate("/admin/sessions"),
          //   label: "Sessions",
          //   icon: ListBulletedFilledIcon,
          //   selected: window.location.href.indexOf("/admin/sessions") > -1,
          // },
        ]}
      ></Navigation.Section>
      <Navigation.Section
        separator
        items={[
          {
            label: "Settings",
            url: "/",
            onClick: () => navigate("/admin/settings/users-and-permissions"),
            icon: SettingsFilledIcon,
            selected: window.location.href.indexOf("/admin/settings") > -1,
            subNavigationItems: [
              {
                onClick: () =>
                  navigate("/admin/settings/users-and-permissions"),
                selected:
                  window.location.href.indexOf(
                    "/admin/settings/users-and-permissions",
                  ) > -1 && true,
                label: "Users and Permissions",
                icon: PersonFilledIcon,
              },
              {
                onClick: () => navigate("/admin/settings/currency"),
                selected:
                  window.location.href.indexOf("/admin/settings/currency") >
                    -1 && true,
                label: "Currency",
                icon: CashDollarFilledIcon,
              },
              {
                onClick: () => navigate("/admin/settings/contact-us"),
                selected:
                  window.location.href.indexOf("/admin/settings/contact-us") >
                    -1 && true,
                label: "Contact us Email",
                icon: EmailIcon,
              },
            ],
          },
        ]}
      />
    </Navigation>
  );
  const loadingMarkup = isLoading ? <Loading /> : null;

  const skipToContentTarget = (
    <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
  );

  const actualPageMarkup = (
    <Page title="Account">
      <Layout>
        {skipToContentTarget}
        <Layout.AnnotatedSection
          title="Account details"
          description="Jaded Pixel will use this as your account information."
        >
          <Card sectioned>
            <FormLayout>
              <TextField
                label="Full name"
                value={nameFieldValue}
                onChange={handleNameFieldChange}
              />
              <TextField
                type="email"
                label="Email"
                value={emailFieldValue}
                onChange={handleEmailFieldChange}
              />
            </FormLayout>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </Page>
  );

  const loadingPageMarkup = (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <Text>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={9} />
            </Text>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );

  const pageMarkup = isLoading ? loadingPageMarkup : actualPageMarkup;

  const modalMarkup = (
    <Modal
      open={modalActive}
      onClose={toggleModalActive}
      title="Contact support"
      primaryAction={{
        content: "Send",
        onAction: toggleModalActive,
      }}
    >
      <Modal.Section>
        <FormLayout>
          <TextField
            label="Subject"
            value={supportSubject}
            onChange={handleSubjectChange}
          />
          <TextField
            label="Message"
            value={supportMessage}
            onChange={handleMessageChange}
            multiline
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );

  const theme = {
    colors: {
      surface: "#FFFFFF",
      onsurface: "#212B36",
    },
  };
  const logo = {
    width: 150,

    topBarSource: logoImg,
    // url: "/admin/employees",
    // accessibilityLabel: "Jaded Pixel",
  };

  useEffect(() => {}, []);

  return (
    <div style={{ height: "500px" }}>
      <AppProvider
        // theme={theme}
        i18n={{
          Polaris: {
            Avatar: {
              label: "Avatar",
              labelWithInitials: "Avatar with initials {initials}",
            },
            ContextualSaveBar: {
              save: "Save",
              discard: "Discard",
            },
            TextField: {
              characterCount: "{count} characters",
            },
            TopBar: {
              toggleMenuLabel: "Toggle menu",

              SearchField: {
                clearButtonLabel: "Clear",
                search: "Search",
              },
            },
            Modal: {
              iFrameTitle: "body markup",
            },
            Frame: {
              skipToContent: "Skip to content",
              Navigation: {
                closeMobileNavigationLabel: "Close navigation",
              },
            },
          },
        }}
      >
        <Frame
          topBar={topBarMarkup}
          navigation={navigationMarkup}
          showMobileNavigation={mobileNavigationActive}
          onNavigationDismiss={toggleMobileNavigationActive}
          skipToContentTarget={skipToContentRef.current}
          logo={logo}
        >
          {props.children}
        </Frame>
      </AppProvider>
    </div>
  );
}
export default React.memo(NavigationLayout);
